<kno2-table
    [columns]="columns()"
    [data]="messages().items"
    [rowActions]="rowActions">
    <ng-template
        #subject
        let-draft>
        <a
            class="kno2-link"
            [routerLink]="['/release/draft', draft.id]">
            {{ draft.subject }}
        </a>
    </ng-template>
    <ng-template
        #toAddress
        let-draft>
        <span
            data-bs-toggle="tooltip"
            [title]="draft.toAddress">
            {{ draft?.toAddress || "N/A" }}
        </span>
    </ng-template>
    <ng-template
        #fromAddress
        let-draft>
        <span
            data-bs-toggle="tooltip"
            [title]="draft.fromAddress">
            {{ draft?.fromAddress || "N/A" }}
        </span>
    </ng-template>
</kno2-table>

<kno2-pagination
    [collectionSize]="messages().totalCount"
    [page]="pageOptions().pageStart"
    [showPageInput]="true"
    [pageSize]="pageOptions()?.pageSize"
    (pageChange)="updateMessagesQuery({ pageStart: $event })" />
<ng-template
    #rowActions
    let-draft>
    <button
        (click)="editDraft(draft.id)"
        class="btn"
        alt="Edit"
        data-bs-toggle="tooltip"
        title="Edit">
        <i class="fa fa-pencil"></i>
    </button>
    <button
        (click)="deleteDraft(draft.id)"
        class="btn ms-1"
        alt="Delete"
        data-bs-toggle="tooltip"
        title="Delete">
        <i class="fa fa-trash"></i>
    </button>
</ng-template>
